import React, { useMemo } from 'react';
import { InputList, useInputHelper } from 'framework/form';
import TeamPositionsWithQualificationForm from '../forms/TeamPositionsWithQualificationForm';
import { ExpectedStructureType, MapedExpectedStructure } from 'domain/shared/newProject';

type TeamInputListProps = {
  source: string;
  isUpdate?: boolean;
};

type TeamInputListItem = ExpectedStructureType & {
  isNewPosition?: boolean;
  qualification?: string | null;
};

const TeamInputList = ({ source, isUpdate }: TeamInputListProps) => {
  const { getValue } = useInputHelper<TeamInputListItem[]>({ source });
  const isOldStructure = useMemo(
    () => (getValue() || []).some((item: TeamInputListItem) => item.qualification) || false,
    [getValue],
  );

  return (
    <InputList
      inputTemplate={TeamPositionsWithQualificationForm}
      inputProps={{ isOldStructure: isOldStructure, isUpdate: isUpdate }}
      source={source}
      addText="Add position"
      disabledRemove={(data: MapedExpectedStructure) => !!data?.members?.length}
      removeButtonTooltipe={(data: MapedExpectedStructure) => (!!data?.members?.length ? 'Slot is not empty.' : null)}
      maxFields={30}
      defaultValue={{ isNewPosition: true, _isExistingSOWReplacementPosition: false }}
    />
  );
};

export default TeamInputList;
